import React from 'react'
import Footer from '../../component/Other/Footer'
import Navbar from '../../component/Other/Navbar'
import Faq from '../../component/Page/Faq'
import Program from '../../component/Page/Program'
import Testimonial from '../../component/Page/Testimonial'

const Programs = () => {
    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />
            <Faq />

            <Testimonial />

            <Footer />
        </div>
    )
}

export default Programs